import { render, staticRenderFns } from "./AdminSuperReporting.vue?vue&type=template&id=75316b6c&lang=pug&"
import script from "./AdminSuperReporting.vue?vue&type=script&lang=js&"
export * from "./AdminSuperReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports